export const getters = {
    zkteco_user: state => state.zkteco_user,
    createZktecoUser:state=>state.createZktecoUser,
    company_device_ids:state=>state.company_device_ids ,
    location_ids:state=>state.location_ids  
};
